export default __webpack_public_path__ + "static/media/svgviewer-output(5).607f9bb6.svg";